import { root } from './info';

export const info = {
  ...root,
};
